<template lang="html">
  <!-- Page principale Etablissements -->
  <div style="margin: 10px 10px; display: flex; flex-direction: column; height: 94vh;min-width:1440px;">
    <div class="page-title-container">
      <div class="row">
        <div class="col-12 col-md-8 mb-3 mb-md-0 me-auto">
          <h1 class="mb-0 pb-0 display-4" id="title">Établissements</h1>
        </div>
      </div>
    </div>
    <div class="columns"
         style="flex-grow: 1; display: flex; margin: 0; max-height: 95%;">
      <div class="column is-3"
           style="display: flex; flex-grow: 1; flex-direction: column; max-height: 100%; min-width: 280px;">
        <EstablishmentListFilterTeam :selectable="true" />
      </div>
      <div class="column is-5"
           style="flex-grow: 1; display: flex; flex-direction: column; max-height: 100%; min-width: 490px;">
        <EstablishmentCard
            v-if="establishment && establishment.uid"
            :establishment="establishment"
        />

        <div v-if="establishment && establishment.uid"
             class="card"
             style="flex-grow: 1; display: flex; flex-direction: column;">
          <div class="card-body"
               style="flex-grow: 1; display: flex; flex-direction: column;">
            <EtherPad :padkey="'pad-'+$store.state.selected_establishment_uid"
                      v-if="$store.state.selected_establishment_uid != null"
                      height="100%">
            </EtherPad>
          </div>
        </div>
      </div>
      <div class="column is-4"
           style="display: flex; flex-grow: 1; flex-direction: column; max-height: 100%;  min-width: 400px;">
        <div class="card mb-3"
             style="flex-grow: 1; display: flex; flex-direction: column; max-height: 66%;">
          <div class="card-body"
               style="flex-grow: 1; display: flex; flex-direction: column; max-height: 100%;overflow:hidden;">
            <ReviewListPaginated
                parentPage="establishment"
                title=""
                :autoload="loadReviews"
                :filters="computed_filters"
            />
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div>
              <TextForNextReport
                  v-if="establishment && establishment.uid"
                  :establishment="establishment"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <EstablishmentModal/>
  </div>
</template>

<script>
import ReviewListPaginated from '@/components/ReviewListPaginated.vue'
import EstablishmentDetail from '@/components/EstablishmentDetail.vue'
import EstablishmentCard from '@/components/EstablishmentCard.vue'
import EstablishmentListFilterTeam from '@/components/EstablishmentListFilterTeam.vue'
import EtherPad from '@/components/Etherpad.vue'
import TextForNextReport from '@/components/TextForNextReport.vue'
import EstablishmentModal from '@/components/EstablishmentModal.vue'
import utils from '@/utils.js'
import ESTABLISHMENT_DETAIL from '@/gql/queries/establishmentDetail.graphql'
import { gqlQuery } from '@/gqlClient.js'

export default {
  name: 'establishment',
  components: {
    ReviewListPaginated,
    EstablishmentListFilterTeam,
    EstablishmentDetail,
    EstablishmentCard,
    EtherPad,
    TextForNextReport,
    EstablishmentModal
  },
  data() {
    return {
      padHeight: (window.innerHeight - 253) + 'px',
      loadReviews: false,
      establishment: null
    }
  },
  computed: {
    computed_filters() {
      return {
        establishment: {uid: this.$store.state.selected_establishment_uid}
      }
    },
  },
  methods: {
    async fetch_establishment(uid) {
      const res = await gqlQuery(ESTABLISHMENT_DETAIL, { id: uid });
      this.establishment = res.body.data.establishment || null;
    }
  },
  mounted() {
    this.$djangows.onmodelsignals({ appLabel: 'establishment', modelName: 'establishment' }, () => {
      if (this.$store.state.selected_establishment_uid) {
        this.fetch_establishment(this.$store.state.selected_establishment_uid);
      }
    });
  },
  watch: {
    '$store.state.selected_establishment_uid'(newV, oldV) {
      if (newV && newV !== oldV) {
        this.fetch_establishment(newV);
      }
    }
  }
}
</script>


<style lang=scss scoped>

</style>
